"use client";

import { useEffect } from "react";
import clarity from "@microsoft/clarity";

const clarityProjectId = "up7ftvqe1u";
let clarityInitialized = false;

export function ClarityAnalytics() {
  useEffect(() => {
    if (clarityInitialized) {
      return;
    }

    try {
      clarity.init(clarityProjectId);
      clarityInitialized = true;
    } catch (error) {
      console.error("Failed to initialize Microsoft Clarity", error);
    }
  }, []);

  return null;
}
